/**
 * FAQ search + category filter.
 * Self-contained vanilla custom element — no external libraries,
 * no dependency on other theme modules. Filters accordion rows
 * client-side by category (data-category) and free-text search
 * (matches against each row's rendered text content).
 */
class FaqSearchComponent extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-faq-search-input]');
    this.categoryButtons = Array.from(this.querySelectorAll('[data-faq-category]'));
    this.rows = Array.from(this.querySelectorAll('details[data-category]'));
    this.emptyState = this.querySelector('[data-faq-empty-state]');
    this.activeCategory = 'all';

    if (this.categoryButtons.length > 0) {
      this.categoryButtons[0].classList.add('is-active');
      this.activeCategory = this.categoryButtons[0].getAttribute('data-faq-category') || 'all';
    }

    if (this.input) {
      this.input.addEventListener('input', () => this.filter());
    }

    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.getAttribute('data-faq-category') || 'all';
        this.categoryButtons.forEach((otherButton) => {
          otherButton.classList.toggle('is-active', otherButton === button);
        });
        this.filter();
      });
    });
  }

  filter() {
    const query = (this.input && this.input.value ? this.input.value : '').trim().toLowerCase();
    let visibleCount = 0;

    this.rows.forEach((row) => {
      const category = row.getAttribute('data-category') || '';
      const matchesCategory = this.activeCategory === 'all' || category === this.activeCategory;
      const matchesSearch = query === '' || row.textContent.toLowerCase().includes(query);
      const isVisible = matchesCategory && matchesSearch;

      row.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount !== 0;
    }
  }
}

if (!customElements.get('faq-search-component')) {
  customElements.define('faq-search-component', FaqSearchComponent);
}
